<template>
  <div>
    <v-row
      no-gutters
      class="px-1"
    >
      <v-col
        class="grey--text text--darken-1 font-weight-bold"
      >
        Base Price
      </v-col>
      <v-col
        cols="auto"
        class="text-no-wrap grey--text text--darken-1 font-weight-bold"
      >
        {{ liveBasePrice | currency(currency) }}
      </v-col>
    </v-row>
    <v-divider class="my-2 grey darken-4" />
    <v-row
      no-gutters
      class="px-1"
    >
      <v-col
        class="grey--text text--darken-1 font-weight-bold"
      >
        Options
      </v-col>
      <v-col
        cols="auto"
        class="text-no-wrap grey--text text--darken-1 font-weight-bold"
      >
        {{ liveEquipmentPrice | currency(currency) }}
      </v-col>
    </v-row>
    <v-divider
      v-if="!condensed && equipmentPacks.length > 0"
      class="my-2 grey darken-4"
    />
    <div v-if="!condensed">
      <div>
        <v-row
          no-gutters
          class="px-1"
        >
          <v-col class="font-weight-medium">
            Factory Options
          </v-col>
          <v-col
            cols="auto"
            class="text-no-wrap grey--text text--darken-1 font-weight-medium"
          >
            {{ liveYardEquipmentPrice | currency(currency) }}
          </v-col>
        </v-row>
        <template v-for="equipmentPack in yardEquipment">
          <small-pricing-list-equipment-row
            :key="'yard'+equipmentPack.id"
            :equipment-pack="equipmentPack"
          />
        </template>
      </div>
      <div class="mt-2">
        <v-row
          no-gutters
          class="px-1"
        >
          <v-col class="font-weight-medium">
            Other Options
          </v-col>
          <v-col
            cols="auto"
            class="text-no-wrap grey--text text--darken-1 font-weight-medium"
          >
            {{ liveNonYardNavigareOptionEquipmentPrice | currency(currency) }}
          </v-col>
        </v-row>
        <template v-for="equipmentPack in nonYardNavigareOptionEquipment">
          <small-pricing-list-equipment-row
            :key="'nonyardnavigareoption'+equipmentPack.id"
            :equipment-pack="equipmentPack"
          />
        </template>
      </div>
      <div class="mt-2">
        <v-row
          no-gutters
          class="px-1"
        >
          <v-col class="font-weight-medium">
            Charter & Safety Pack
          </v-col>
          <v-col
            cols="auto"
            class="text-no-wrap grey--text text--darken-1 font-weight-medium"
          >
            {{ liveNonYardSafetyCharterEquipmentPrice | currency(currency) }}
          </v-col>
        </v-row>
        <template v-for="equipmentPack in nonYardSafetyCharterEquipment">
          <small-pricing-list-equipment-row
            :key="'nonyard'+equipmentPack.id"
            :equipment-pack="equipmentPack"
          />
        </template>
      </div>
    </div>
    <v-divider class="my-2 grey darken-4" />
    <v-row
      no-gutters
      class="px-1"
    >
      <v-col
        class="grey--text text--darken-1 font-weight-bold"
      >
        CDR Cost
      </v-col>
      <v-col
        cols="auto"
        class="text-no-wrap font-weight-bold grey--text text--darken-1"
      >
        {{ liveCdrPrice | currency(currency) }}
      </v-col>
    </v-row>
    <v-divider
      v-if="!condensed && cdrEquipmentPacks.length > 0"
      class="my-2 grey darken-4"
    />
    <div v-if="!condensed">
      <template v-for="equipmentPack in cdrEquipmentPacks">
        <v-row
          :key="equipmentPack.id"
          no-gutters
          class="px-1 py-1 list--bordered"
        >
          <v-col
            class="grey--text text--darken-1 text-truncate"
          >
            {{ equipmentPack.label }}
          </v-col>
          <v-col
            cols="auto"
            class="text-no-wrap"
          >
            {{ equipmentPack.sale_price | currency(equipmentPack.currency) }}
          </v-col>
        </v-row>
      </template>
    </div>
    <div v-if="liveProductionPriceIncrease">
      <v-divider
        class="my-2 grey darken-4"
      />
      <v-row
        no-gutters
        class="px-1 body-2"
      >
        <v-col
          class="grey--text text--darken-1 font-weight-bold"
        >
          Subtotal
        </v-col>
        <v-col
          cols="auto"
          class="grey--text text--darken-1 ml-2 text-no-wrap font-weight-black"
        >
          {{ liveTotalPrice - liveProductionPriceIncrease | currency(currency) }}
        </v-col>
      </v-row>
      <v-divider
        class="my-2 grey darken-4"
      />
      <v-row
        no-gutters
        class="px-1 body-2"
      >
        <v-col
          class="red--text text--darken-1 font-weight-bold"
        >
          Model Year Price Increase
        </v-col>
        <v-col
          cols="auto"
          class="red--text text--darken-1 ml-2 text-no-wrap font-weight-black"
        >
          + {{ liveProductionPriceIncrease | currency(currency) }} ({{ liveProductionPriceIncrease / (liveTotalPrice - liveProductionPriceIncrease) | percentage }})
        </v-col>
      </v-row>
    </div>
    <v-divider class="my-2 grey darken-4" />
    <v-row
      no-gutters
      class="px-1 body-2"
    >
      <v-col
        class="primary--text font-weight-bold"
      >
        Total
      </v-col>
      <v-col
        cols="auto"
        class="primary--text ml-2 text-no-wrap font-weight-black"
      >
        {{ liveTotalPrice | currency(currency) }}
      </v-col>
    </v-row>
    <v-row
      v-if="exchangeRatesCleaned.length > 0"
      no-gutters
      class="grey--text mt-4 caption"
    >
      <v-col>
        Exchange rates
      </v-col>
      <v-col cols="auto">
        <v-chip
          v-for="rate in exchangeRatesCleaned"
          :key="'rate_' + rate.base + rate.quote"
          label
          small
          outlined
          color="grey"
          class="mr-1"
        >
          {{ rate.base }}/{{ rate.quote }}: {{ rate.rate }}
        </v-chip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import YachtEquipmentPack from '@/models/YachtEquipmentPack'
import SmallPricingListEquipmentRow from '@/components/business/yachts/SmallPricingListEquipmentRow.vue'
import { uniqBy } from 'lodash'

export default {
  name: 'SmallPricingList',
  components: { SmallPricingListEquipmentRow },
  props: {
    condensed: {
      type: Boolean,
      default: false
    },
    basePrice: {
      type: [Number, String],
      required: true
    },
    baseCurrency: {
      type: String,
      required: true
    },
    equipmentPacks: {
      type: Array,
      default: () => []
    },
    equipmentPrice: {
      type: [Number, String],
      default: 0
    },
    cdrCost: {
      type: [Number, String],
      default: 0
    },
    currency: {
      type: String,
      default: 'EUR'
    },
    productionYearPriceIncrease: {
      type: [Number, String],
      default: 0
    },
    totalPrice: {
      type: [Number, String],
      default: 0
    },
    liveCalculation: {
      type: Boolean,
      default: false
    },
    currencyExchangeYear: {
      type: [Number, String],
      default: undefined
    },
    yearlyPriceIncrease: {
      type: Number,
      default: 0
    },
    productionYear: {
      type: [Number, String],
      default: undefined
    },
    modelYear: {
      type: [Number, String],
      default: undefined
    },
    exchangeRates: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      liveBasePrice: 0,
      liveEquipmentPrice: 0,
      liveCdrPrice: 0,
      liveProductionPriceIncrease: 0,
      liveTotalPrice: 0,
      liveYardEquipmentPrice: 0,
      liveNonYardEquipmentPrice: 0,
      liveNonYardNavigareOptionEquipmentPrice: 0,
      liveNonYardSafetyCharterEquipmentPrice: 0,
      exchangeYear: (new Date()).getFullYear()
    }
  },
  computed: {
    equipmentPacksWithoutCdr() {
      return this.equipmentPacks.filter(ep => ep.category && !ep.category.is_cdr)
    },
    yardEquipment() {
      return this.equipmentPacksWithoutCdr.filter(ep => ep.installed_by === YachtEquipmentPack.INSTALLED_BY_SHIPYARD)
    },
    nonYardEquipment() {
      return this.equipmentPacksWithoutCdr.filter(ep => ep.installed_by !== YachtEquipmentPack.INSTALLED_BY_SHIPYARD)
    },
    nonYardNavigareOptionEquipment() {
      return this.nonYardEquipment.filter(ep => ep.category && ep.category.is_navigare_option)
    },
    nonYardSafetyCharterEquipment() {
      return this.nonYardEquipment.filter(ep => ep.category && !ep.category.is_navigare_option)
    },
    cdrEquipmentPacks() {
      return this.equipmentPacks.filter(ep => ep.category && ep.category.is_cdr)
    },
    exchangeRatesCleaned() {
      return uniqBy(this.exchangeRates.filter(r => parseFloat(r.rate) !== 1), function (r) {
        return r.base + r.quote
      })
    },
    ...mapState('settings', ['currencyExchangeRates'])
  },
  watch: {
    equipmentPacks: {
      deep: true,
      handler: function () {
        this.calculateAll()
      }
    },
    liveCalculation() {
      this.calculateAll()
    },
    totalPrice() {
      this.calculateAll()
    },
    currency() {
      this.calculateAll()
    },
    cdrCost() {
      this.calculateAll()
    },
    basePrice() {
      this.calculateAll()
    },
    baseCurrency() {
      this.calculateAll()
    },
    productionYearPriceIncrease() {
      this.calculateAll()
    },
    currencyExchangeYear() {
      this.calculateAll()
    },
    yearlyPriceIncrease() {
      this.calculateAll()
    },
    productionYear() {
      this.calculateAll()
    },
    modelYear() {
      this.calculateAll()
    }
  },
  created() {
    this.calculateAll()
  },
  methods: {
    calculateAll() {
      this.checkIfCurrencyPairsExist()

      this.exchangeYear = this.currencyExchangeYear

      if (!this.exchangeYear) {
        this.exchangeYear = this.productionYear || (new Date()).getFullYear()
      }

      this.liveYardEquipmentPrice = Number(this.yardEquipment.map(pack => this.exchangeCurrency(pack.sale_price || 0, pack.currency, this.currency, this.exchangeYear))
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0))
      this.liveNonYardNavigareOptionEquipmentPrice = Number(this.nonYardNavigareOptionEquipment.map(pack => this.exchangeCurrency(pack.sale_price || 0, pack.currency, this.currency, this.exchangeYear))
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0))
      this.liveNonYardSafetyCharterEquipmentPrice = Number(this.nonYardSafetyCharterEquipment.map(pack => this.exchangeCurrency(pack.sale_price || 0, pack.currency, this.currency, this.exchangeYear))
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0))

      if (!this.liveCalculation) {
        this.liveBasePrice = this.basePrice
        this.liveEquipmentPrice = this.equipmentPrice
        this.liveCdrPrice = this.cdrCost
        this.liveProductionPriceIncrease = this.productionYearPriceIncrease
        this.liveTotalPrice = this.totalPrice

        return
      }

      this.liveBasePrice = Number(this.exchangeCurrency(this.basePrice, this.baseCurrency, this.currency, this.exchangeYear))
      this.liveEquipmentPrice = Number(this.equipmentPacks.filter(pack => !pack.category || !pack.category.is_cdr)
        .map(pack => this.exchangeCurrency(pack.sale_price || 0, pack.currency, this.currency, this.exchangeYear))
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0))
      this.liveCdrPrice = Number(this.equipmentPacks.filter(pack => pack.category && pack.category.is_cdr)
        .map(pack => this.exchangeCurrency(pack.sale_price || 0, pack.currency, this.currency, this.exchangeYear))
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0))

      let totalPrice = Number(this.liveBasePrice) + Number(this.liveEquipmentPrice) + Number(this.liveCdrPrice)

      this.liveProductionPriceIncrease = this.getProductionYearPriceIncrease(totalPrice)

      this.liveTotalPrice = totalPrice + Number(this.liveProductionPriceIncrease)
    },
    findExchangeRate(toCurrency, fromCurrency, year) {
      if (toCurrency === fromCurrency) return 1

      let pair = this.currencyExchangeRates.data.find(exchangeRate => {
        if (exchangeRate.base === fromCurrency && exchangeRate.quote === toCurrency && exchangeRate.year.toString() === year.toString()) return true
      })

      if (!pair) return 0

      return pair.rate
    },
    exchangeCurrency(amount, fromCurrency, toCurrency, year) {
      if (fromCurrency === toCurrency) return amount

      return Number((amount || 0) * this.findExchangeRate(toCurrency, fromCurrency, year))
    },
    getProductionYearPriceIncrease(totalPrice) {
      if (!this.productionYear || !this.modelYear || !this.yearlyPriceIncrease) return 0

      const diff = Number(this.productionYear) - Number(this.modelYear)

      if (diff === 0) return 0

      const factor = Math.pow(1 + Number(this.yearlyPriceIncrease), diff < 0 ? 0 : diff)

      return (factor - 1) * totalPrice
    },
    checkIfCurrencyPairsExist() {
      let targetCurrency = this.currency
      let yachtModelCurrency = this.baseCurrency
      let yachtModelYear = this.exchangeYear

      let notFound = null

      if (!this.findExchangeRate(targetCurrency, yachtModelCurrency, yachtModelYear)) {
        notFound = {
          object: 'yachtModel',
          target: targetCurrency,
          source: yachtModelCurrency,
          year: yachtModelYear
        }
      }

      for (let equipmentPack of this.equipmentPacks) {
        if (!this.findExchangeRate(targetCurrency, equipmentPack.currency, yachtModelYear)) {
          notFound = {
            object: 'yachtEquipmentPack',
            id: equipmentPack.id || null,
            pack: equipmentPack.label,
            target: targetCurrency,
            source: equipmentPack.currency,
            year: yachtModelYear
          }
        }
      }

      if (notFound !== null) {
        if (notFound.object === 'yachtModel') {
          this.$store.dispatch('alert', {
            text: `Currency exchange rate for yacht model ${notFound.source}->${notFound.target} (for year ${notFound.year}) was not found!`,
            color: 'error',
            multiline: true
          })
        } else if (notFound.object === 'yachtEquipmentPack') {
          this.$store.dispatch('alert', {
            text: `Currency exchange rate for equipment pack ${notFound.pack}, ${notFound.source}->${notFound.target} (for year ${notFound.year}) was not found!`,
            color: 'error',
            multiline: true
          })
        }

        let error = new Error('Currency exchange rate cannot be found')
        error.context = notFound

        throw error
      }
    }
  }
}
</script>
